import "./App.css";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";
import GalleryPage from "./pages/GalleryPage";
import Pools from "./pages/Pools/Pools";
import Patio from "./pages/Patio/Patio";
import Stucco from "./pages/Stucco";
import Kitchen from "./pages/Kitchen/Kitchen";
import Yardscape from "./pages/Yardscape/Yardscape";
import Contact from "./pages/Contact/Contact";

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

function App() {
    return (
        <>
            <Router>
                <ScrollToTop />
                <Navbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/gallery" element={<GalleryPage />} />
                    <Route path="/pools" element={<Pools />} />
                    <Route path="/patio" element={<Patio />} />
                    <Route path="/stucco" element={<Stucco />} />
                    <Route path="/kitchen" element={<Kitchen />} />
                    <Route path="/yardscape" element={<Yardscape />} />
                    <Route path="/contact" element={<Contact />} />
                </Routes>
                <Footer />
            </Router>
        </>
    );
}

export default App;
